import { render, staticRenderFns } from "./scoreDialog.vue?vue&type=template&id=4209763c&scoped=true&"
import script from "./scoreDialog.vue?vue&type=script&lang=js&"
export * from "./scoreDialog.vue?vue&type=script&lang=js&"
import style0 from "./scoreDialog.vue?vue&type=style&index=0&id=4209763c&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4209763c",
  null
  
)

export default component.exports